import { render, staticRenderFns } from "./factory-task.vue?vue&type=template&id=09c8e788&scoped=true"
import script from "./factory-task.vue?vue&type=script&lang=ts"
export * from "./factory-task.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8e788",
  null
  
)

export default component.exports